import React, { useMemo, useCallback } from "react";
import { useSelector } from "react-redux";
import { helpers, format } from "../../../../common/lib";

/**
 * Use Audit Summary Data Hook
 */

export default () => {
    const { assets, auditsCreate, typesList, branches, locations } =
        useSelector((state) => state);

    /* In typesList get the attribute condition id  by using name  */
    const attributeIds = useMemo(() => {
        const { attributes } = typesList;
        const attributeName = [];
        attributes.data.map((item) => attributeName.push(item.name));
        return attributeName;
    }, [typesList]);

    const getCore = useCallback(
        (value: any) => {
            const make = helpers.getListItemForId(
                typesList.makes,
                value.asset.make
            );
            const type = helpers.getListItemForId(
                typesList.assetTypes,
                value.asset.type
            );
            const attributeList = new Map();
            value.attributes.map((item, idx) => {
                attributeList.set(attributeIds[idx], item.value);
            });

            const branchName = helpers.getListItemForId(
                branches,
                value.branch
            ).name;
            const locationName = helpers.getListItemForId(
                locations,
                value.location
            ).name;

            return {
                identifier1: value.asset.identifier1 || "",
                identifier2: value.asset.identifier2 || "",
                identifier3: value.asset.identifier3 || "",
                identifier4: value.asset.identifier4 || "",
                isExpected: value.isExpected,
                make: make.name,
                type: type.name,
                colour: attributeList.get("colour"),
                model: attributeList.get("model"),
                condition: attributeList.get("condition"),
                odometer: attributeList.get("odometer"),
                modelVariant: attributeList.get("model variant"),
                createdDate: format.dateTimeNew(value.createdDate),
                branch: branchName,
                location: locationName
            };
        },
        [typesList]
    );

    /** Map monetary values with asset value if present */
    const getMonetaryValue = useCallback(
        (item: any) => {
            let monetaryServicesTypes = {};
            typesList.monetaryValueTypes.data.map(
                (item) => (monetaryServicesTypes[item.name] = "")
            );
            item.monetaryValues &&
                item.monetaryValues.length > 0 &&
                item.monetaryValues.forEach((val) => {
                    if (val.monetaryValueTypeId !== -1) {
                        const monetaryValueName = helpers.getListItemForId(
                            typesList.monetaryValueTypes,
                            val.monetaryValueTypeId
                        ).name;
                        monetaryServicesTypes[monetaryValueName] = val.amount;
                    }
                });
            return monetaryServicesTypes;
        },
        [typesList]
    );

    const selectedData = useMemo(() => {
        const { selectedBranches, data } = auditsCreate;
        const currentBranch = [];

        /** Get the branches which are selected */
        data.map((item) => {
            if (selectedBranches.includes(item.id)) {
                currentBranch.push(item.branch);
            }
        });
        /** Filter out asset based on the branch */
        const next = assets.data.filter((item) => {
            if (currentBranch.includes(item.branch)) return item;
        });
        return next;
    }, [auditsCreate, assets]);

    /** Map services with the name with the typeslist  */
    const monetaryServicesCols = useMemo(() => {
        const monetaryServicesTypes = [];
        typesList.monetaryValueTypes.data.map((item) =>
            monetaryServicesTypes.push({ id: item.name })
        );
        return monetaryServicesTypes;
    }, [typesList.monetaryValueTypes]);

    const columns = [
        { id: "identifier1" },
        { id: "identifier2" },
        { id: "identifier3" },
        { id: "identifier4" },
        { id: "make" },
        { id: "type" },
        { id: "colour" },
        { id: "model" },
        { id: "condition" },
        { id: "odometer" },
        { id: "modelVariant" },
        { id: "createdDate" },
        { id: "branch" },
        { id: "location" },
        { id: "isExpected" },
        ...monetaryServicesCols
    ];
    
    /** Construct data for the csv */
    const data = useMemo(() => {
        return selectedData.map((item) => {
            return { ...getMonetaryValue(item), ...getCore(item) };
        });
    }, [typesList, selectedData]);

    return { data, columns };
};
